import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import useList from './useList';
import ListDesktop from './desktop';
import ListMobile from './mobile';

const OrderList = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useList();

  return isMobile ? <ListMobile viewModel={viewModel} /> : <ListDesktop viewModel={viewModel} />;
};

export default OrderList;
